import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "banner w-full lg:h-18 md:h-60 h-48 relative" }
const _hoisted_3 = { class: "flex items-center flex-column w-full h-full" }
const _hoisted_4 = { class: "container mx-auto" }
const _hoisted_5 = { class: "flex flex-col items-center w-full container" }
const _hoisted_6 = {
  key: 0,
  class: "bg-gray-200 h-14 w-full flex items-center sticky top-0 drop-shadow-sm"
}
const _hoisted_7 = { class: "flex container md:justify-around items-center lg:mx-64 mx-6 md:overflow-auto overflow-scroll" }
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = {
  key: 1,
  class: "h-full w-full flex items-center mt-8"
}
const _hoisted_10 = { class: "container lg:mx-96 mx-6" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "lg:text-2xl text-md lg:w-3/4 w-2/4" }
const _hoisted_13 = {
  key: 0,
  class: "lg:text-md text-sm flex flex-row justify-between lg:w-1/4 w-2/4 text-center"
}
const _hoisted_14 = { class: "bg-white" }
const _hoisted_15 = { class: "w-full flex justify-between px-4 py-3" }
const _hoisted_16 = { class: "flex flex-col lg:w-3/4 w-2/4" }
const _hoisted_17 = { class: "text-gray-600 lg:text-lg text-sm font-bold" }
const _hoisted_18 = { class: "text-gray-400 lg:text-sm text-xs font-medium leading-3" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "h-px w-full bg-pink-900 bg-opacity-25"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_divider_component = _resolveComponent("divider-component")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_divider_component, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Menu")
                ])),
                _: 1,
                __: [0]
              })
            ])
          ])
        ])
      ])
    ]),
    (_ctx.loading === false)
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (categorie, catIndex) => {
              return (_openBlock(), _createElementBlock("a", {
                key: catIndex,
                class: _normalizeClass([{
            'bg-pink-700': catIndex == _ctx.selectedCategory,
            'text-white': catIndex == _ctx.selectedCategory,
            'rounded-md': catIndex == _ctx.selectedCategory,
          }, "p-2 text-center whitespace-nowrap font-medium"]),
                href: '#' + categorie,
                onClick: ($event: any) => (_ctx.selectedCategory = catIndex)
              }, _toDisplayString(categorie), 11, _hoisted_8))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading === false)
      ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (cat, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{ 'mt-0': index === 0 }, "lg:my-10 my-6"])
              }, [
                _createElementVNode("div", {
                  id: cat.title,
                  class: "bg-pink-700 text-white font-bold px-4 lg:py-3 py-2 flex justify-between anchor"
                }, [
                  _createElementVNode("h3", _hoisted_12, _toDisplayString(cat.title), 1),
                  (cat.sizes.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.sizes.reverse(), (size, sizeIndex) => {
                          return (_openBlock(), _createElementBlock("h3", {
                            key: sizeIndex,
                            class: "w-1/4"
                          }, _toDisplayString(size.title), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_11),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.items.reverse(), (item, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("h3", _hoisted_17, _toDisplayString(item.name), 1),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(item.ingredients), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass([item.prices.length > 1 ? 'justify-between' : 'justify-end', "lg:text-md text-sm flex flex-row lg:w-1/4 w-2/4"])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.prices.reverse(), (price, priceIndex) => {
                            return (_openBlock(), _createElementBlock("h3", {
                              key: priceIndex,
                              class: "text-pink-800 lg:text-md text-sm font-bold text-center w-1/4 whitespace-nowrap"
                            }, [
                              (price.value !== '')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "€" + _toDisplayString(price.value), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 2)
                      ]),
                      (i !== cat.items.length - 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ], 2))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}